var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenInNewWindow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#464455;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.1}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m10.4 25v-12.5c0-1.2 0.9-2.1 2.1-2.1h25c1.2 0 2.1 0.9 2.1 2.1v25c0 1.2-0.9 2.1-2.1 2.1h-12.5m0-14.6l-14.6 14.6m14.6-14.6v8.1m-8.1-8.1h8.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInNewWindow);
export default __webpack_public_path__ + "static/media/open-in-new-window.9a40fe0434261f16299519e1f4d062fe.svg";
export { ForwardRef as ReactComponent };